let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5afiz")).then(() => parcelRequire('244Rz'));